<template>
  <div v-if="data.item !== undefined">
    <div v-if="this.btnSpinGetDetail == false">
      <v-btn :color="ui.bkgdColor" @click="getDashDocuments()"
              icon v-if="data.size == 'icon'">
        <v-icon :color="ui.btnColor"> apps </v-icon>
      </v-btn>
      <v-btn :color="ui.btnColor" @click="getDashDocuments()"
              flat v-if="data.size == 'flat'">
        <v-icon left> {{btnObj.icon}} </v-icon>
        {{btnObj.title}}
      </v-btn>
    </div>
    <div v-else>
      <BtnSpin v-if="data.size == 'icon'" :btnSpec="btnInfo1"/>
      <BtnSpin v-if="data.size == 'flat'" :btnSpec="btnInfo2"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";

export default {
  mixins: [
    apptheme,
    accessFunctions,
    dataSources,
    getData,
    storeFunctions,
    docLogFunctions
  ],
  components: {
    BtnSpin
  },
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(["getDetail", "getUser"]),
    btnObj() {
      let obj = {
        icon: "",
        title: ""
      };
      if (this.data.tag === "U1.Dash") {
        obj.icon = "apps";
        obj.title = "Manage";
      }
      if (this.data.tag === "C1.Dash") {
        obj.icon = "apps";
        obj.title = "Manage";
      }
      if (this.data.tag === "F1.Dash") {
        obj.icon = "apps";
        obj.title = "Manage";
      }
      if (this.data.tag === "A1.Dash") {
        obj.icon = "source";
        obj.title = "Asset";
      }
      return obj;
    }
  },
  data() {
    return {
      valid: false,
      btnSpinGetDetail: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "icon"
      },
      btnInfo2: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "flat"
      }
    };
  },
  methods: {
    getDashDocuments() {
      this.btnSpinGetDetail = true;
      let tag = this.data.tag;
      let did = null;

      // RESET prior to new search
      this.$store.dispatch("changeSearchResults", null);
      this.$store.dispatch("changePageInfo", null);

      // INIT Document Log
      this.prepareForDocumentLog();

      // OTHERS
      if (tag === "C1" || tag === "C1.Dash") {
        did = this.getUser.pref.select.cdid;
      }

      if (tag === "F1" || tag === "F1.Dash") {
        did = this.getUser.pref.select.fdid;
      }

      if (tag === "U1" || tag === "U1.Dash") {
        did = this.getUser.basic.did;
      }

      if (did !== null) {
        this.getDashboardThenPage(tag, did);
      }
    }
  }
};
</script>
